// Import the decryptAES function from a CryptoService module.
import { decryptAES } from "../../services/CryptoService";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";

// Function to transform a successful response.
const { error } = SwalAlert();

export const transformSucessResponse = (response, meta, arg) => {

    let rData = response.responseData;
    let apiData = rData;
    // Check if the response is encrypted.
    if (response.isEnType) {
        rData = decryptAES(rData); // Decrypt the data.
        apiData = rData
    }
    else if (meta.request.url.includes('CheckCookies')) {
        apiData = response;
        return apiData;
    }
    else if (meta.request.url.includes('GetFile') && arg?.fileName) {
        apiData = response;
    }
    else if (meta.request.url.includes('ExportCandidateListReport') || meta.request.url.includes('ExportCandidates')) {
        apiData = response;
        return apiData;
    }
    else if (meta.request.url.includes('ExportCandidateListReportByChannelandSource')) {
        apiData = response;
        return apiData;
    }
    else if (meta.request.url.includes('ExportCandidateListReportByJob')) {
        apiData = response;
        return apiData;
    }
    else if (meta.request.url.includes('ExportCandidateActivityLogReport')) {
        apiData = response;
        return apiData;
    }
    else {

        // Parse the response data into JSON.
        apiData = JSON.parse(rData);
    }


    if (meta.request.url.includes('GetFile') && meta.response.status === 200 && arg.fileName) {
        const responseData = {
            fileName: arg.fileName,
            fileData: apiData
        }
        return responseData;
    }
    // Check if the API response status code is 200 (OK).
    if (apiData.statusCode === 200) {
        return apiData.data; // Return the data.
    } else {
        // Show a toast or alert with the API error message.
        error(apiData.message ? apiData.message : "Something went wrong with the API");
        return null;
    }
}

// Function to transform an error response.
export const transformErrorResponse = (response, meta, arg) => {
    // Check if the API call encountered a network error.
    if (response.status && response.status === "FETCH_ERROR") {
        // Show a toast or alert for network error.
        // error("Oops! Something went wrong while fetching data from the server. Please try again later.");
        ToastService.error("Oops! Something went wrong while fetching data from the server. Please try again later.");
        return null;
    }

    // Check if the API call encountered a parsing error and has a 500 status code.
    if (response.status && response.status === "PARSING_ERROR" && response.originalStatus === 500) {
        const errorMessage = response.data.toLowerCase(); // Convert to lowercase for case-insensitive matching

        // Check if the error message indicates a SQL Server or connection issue.
        if (errorMessage.includes("sql server") || errorMessage.includes("connection") || errorMessage.includes("provider")) {
            ToastService.error("Oops! There was an issue with the SQL Server or database connection. Please try again later and ensure that the SQL Server is configured correctly.");
            return null;

        } else {
            // Show a toast or alert for a generic parsing error.
            error("Oops! There was an issue processing the server's response. Please try again later.");
            return null;

        }
    }

    // Check if the response contains responseData.
    if (response.status && response.data.responseData) {
        let rData = response.data.responseData;

        // Check if the response is encrypted.
        if (response.data.isEnType) {
            rData = decryptAES(rData); // Decrypt the data.
        }

        // Check if the response status code is 400 (Bad Request).
        if (response.status === 400) {
            if (rData.error) {
                let errorMessage = "Validation Error: " + response.message;

                // Iterate through the errors and append them to the error message.
                if (response.errors) {
                    for (const fieldName in response.errors) {
                        if (response.errors.hasOwnProperty(fieldName)) {
                            errorMessage += "\n" + fieldName + ": " + response.errors[fieldName].join("\n");
                        }
                    }
                }

                // Show a toast or alert with the validation error message.
                error(errorMessage);
            }
        }
    }
}
